export enum REFERENCE_TYPE {
	FUNCTIONS = "Functions",
	COMPONETS = "Components",
	INTEGRATIONS = "Integrations",
	ACTIONS = "Actions",
	EVENTS = "Events",
	DATASOURCE = "DataSource"
}

export enum REFERENCE_CHILD_TYPE {
	PROPERTIES = "Properties",
	ARGUMENTS = "Arguments",
	OPTIONS = "Options"
}

export interface ReferenceItemBase {
	label: REFERENCE_TYPE | string;
	description?: string;
	category?: REFERENCE_TYPE | string;
	child?: this[];
	examples?: string;
	hidden?: boolean;
	name?: string;
	type?: string;
}

export interface ReferenceComponent extends ReferenceItemBase {
	defaultValue?: string;
	required?: boolean;
	options?: string[];
	type?: string;
	example?: string;
	constants?: any[];
	childType?: REFERENCE_CHILD_TYPE;
}

export interface ReferenceDataSource extends ReferenceItemBase {
	defaultValue?: string;
	required?: boolean;
	options?: string[];
	type?: string;
	example?: string;
	constants?: any[];
	childType?: REFERENCE_CHILD_TYPE;
}

export interface ReferenceFunction extends ReferenceItemBase {
	defaultValue?: string;
	required?: boolean;
	name?: string;
	type?: string;
	childType?: REFERENCE_CHILD_TYPE;
	returnType?: string;
	argsRest?: {
		type: string;
	};
}

export interface ReferenceIntegration extends ReferenceItemBase {
	defaultValue?: string;
	required?: boolean;
	name?: string;
	hidden?: boolean;
	functions?: ReferenceFunction[];
	childType?: REFERENCE_CHILD_TYPE;
}

export interface ReferenceAction extends ReferenceItemBase {
	type?: string;
	functions?: any;
}

export interface ReferenceEvent extends ReferenceItemBase {
	type?: string;
	functions?: any;
}

export type TReferenceItem = {
	category: string;
	name: string;
	type: string;
};

export type TReferenceData =
	| ReferenceComponent
	| ReferenceFunction
	| ReferenceIntegration
	| ReferenceAction
	| ReferenceEvent
	| ReferenceDataSource;
